import { SkeletonPage } from "@/components/SkeletonLoaders";
import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<SkeletonPage />}>
    <Component {...props} />
  </Suspense>
);

const FitnessHome = Loadable(lazy(() => import("./pages/Home")));
const ActivityDetails = Loadable(lazy(() => import("./pages/ActivityDetails")));
const FitnessSlotsSelection = Loadable(lazy(() => import("./pages/FitnessSlotsSelection")));
const FitnessSummaryPage = Loadable(lazy(() => import("./pages/FitnessSummaryPage")));
const FitnessThanksPage = Loadable(lazy(() => import("./pages/FitnessThanksPage")));
const SubscriptionPage = Loadable(lazy(() => import("./pages/SubscriptionPage")));

const fitnessRoutes = [
  {
    path: "fitness",
    children: [
      {
        index: true,
        element: <Navigate to="20" replace />, // Assuming 20 is a default category ID for fitness, similar to events
      },
      {
        path: ":category_id",
        element: <FitnessHome />,
      },
      {
        path: "subscription/:category_id",
        element: <SubscriptionPage />,
      },
      {
        path: "activity/:serviceId",
        element: <ActivityDetails />,
      },
      {
        path: "slots-selection",
        element: <FitnessSlotsSelection />,
      },
      {
        path: "booking-summary",
        element: <FitnessSummaryPage />,
      },
      {
        path: "thanks",
        element: <FitnessThanksPage />,
      },
    ],
  },
];

export default fitnessRoutes;

